// eslint-disable-next-line import/prefer-default-export
export const ONBOARDING_STATUSES = {
  auth: 'setup_2fa',
  generalInfo: 'general_info',
  location: 'location',
  completed: 'completed',
};
